export default __webpack_public_path__ + "static/media/banner2.e0da17b5.jpg";